
const saveFilter = (filterType: string, field: string, value: string) => {
    const deliveriesFilters = localStorage.getItem(`${filterType}-filters`);

    if (deliveriesFilters) {
        const filters = JSON.parse(deliveriesFilters);
        filters[field] = value;
        localStorage.setItem("deliveries-filters", JSON.stringify(filters));
    } else {
        localStorage.setItem(
            `${filterType}-filters`,
            JSON.stringify({ [field]: value }),
        );
    }
};

const getFilter = (filterType: string) => {
    const deliveriesFilters = localStorage.getItem(`${filterType}-filters`);
    if (deliveriesFilters) {
        const filters = JSON.parse(deliveriesFilters);
        return filters;
    }
    return {};
};

const removeFilter = (filterType: string) => {
    localStorage.removeItem(`${filterType}-filters`);
}

// New version

const fetchFilter = (filterType: string) => {
    const filters = localStorage.getItem(`${filterType}-filters`);
    if (filters) return JSON.parse(filters);
    return null;
};

const setFilter = (filterType: string, filters: any) => {
    const actualFilters = getFilter(filterType);

    if (actualFilters) {
        localStorage.setItem(
            `${filterType}-filters`,
            JSON.stringify({ ...actualFilters, ...filters }),
        );
    } else {
        localStorage.setItem(`${filterType}-filters`, JSON.stringify(filters));
    }
};

// Wipes every list view's cached filters (orders, deliveries, customers...).
// Called on logout so the next session starts from each view's defaults
// instead of resuming whatever the previous user/session had selected.
const clearAllFilters = () => {
    Object.keys(localStorage)
        .filter((key) => key.endsWith('-filters'))
        .forEach((key) => localStorage.removeItem(key));
};

// Wipes the per-session cache (pilotageOkr flag, Crisp identify info) set by AdminLayout.
// Called on logout so a different user logging in on the same tab doesn't inherit
// the previous user's cached email/company (e.g. shown to support in Crisp).
const clearCachedSessionInfo = () => {
    ['pilotageOkrCached', 'crispEmail', 'crispCompany', 'crispName'].forEach((key) =>
        sessionStorage.removeItem(key),
    );
};


export { saveFilter, getFilter, removeFilter, fetchFilter, setFilter, clearAllFilters, clearCachedSessionInfo };
